import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { ICellRendererParams } from 'ag-grid-community';

const tooltipRenderer = (params: ICellRendererParams) => {
  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id={`tooltip-${params.rowIndex}`}>{params.valueFormatted}</Tooltip>}
    >
      <span>{params.valueFormatted}</span>
    </OverlayTrigger>
  );
};

export default tooltipRenderer;



// WEBPACK FOOTER //
// ./src/components/common/StockBoard/CustomTooltip/index.tsx